<template>
<v-row justify="center">
    <v-dialog :value="isOpen" persistent max-width="600">
      <v-card>
        <div class="gh-img">
          <img v-if="type === 'success'" src="/images/check-circle-o.svg" class="gh-icon"/>
          <img v-if="type === 'error'" src="/images/icon_error-circle.svg" class="gh-icon"/>
        </div>
        <v-card-title class="headline">{{ title }}</v-card-title>
        <v-card-text class="gh-message">{{ message }}</v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="green darken-1" text @click="onCloseClick">Close</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-row>
</template>

<script>
export default {
  name: 'ghDialogAlert',

  props: {
    title: {
      type: String
    },

    message: {
      type: String,
      required: true
    },

    type: {
      type: String,
      default: 'success'
    },

    isOpen: {
      type: Boolean,
      default: false
    }
  },

  computed: {
    titleClass () {
      const colorClass = {
        success: 'text-green',
        error: 'text-red'
      }[this.type]

      return [
        'text-h5',
        colorClass
      ]
    }
  },

  methods: {
    onCloseClick () {
      this.$emit('close')
    }
  }
}
</script>

<style scoped lang="sass">
  .gh-img
    display: flex
    justify-content: center
    align-items: center
    padding: 2rem 0

  img
    width: 100px
    height: 100px

  .v-card__title
    justify-content: center
    font-size: 1.8rem !important

  .gh-message
    font-size: 1.5rem
    margin: 2rem 0
    text-align: center
    line-height: 1.7
</style>
